//angular
import { Component, Inject, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from 'src/app/_shared/animations';
import { collectionOfTime, VisibleState } from 'src/app/app.data';
import { BillingRunOperation } from 'src/app/_shared/models/system.model';
import { DataSharingService, LoaderService, UtilsService } from 'src/app/_core/services';
import { FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as dayjs from 'dayjs';

@Component({
  animations: [AppAnimations],
  selector: 'dialog-charge-billing',
  templateUrl: './dialog-charge-billing-runtime.component.html',
  styleUrls: ['./dialog-charge-billing-runtime.component.scss']
})

export class DialogChangeBillingRuntimeComponent implements OnInit {
  date: any;
  selectedRunTime: string;
  dateControl = new FormControl([null, Validators.required]);
  @Input() _collectionOfTimes = collectionOfTime;
  @Input() _data: BillingRunOperation;
  minDate = new Date();
  timezoneOffset: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<DialogChangeBillingRuntimeComponent>,
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    private _sanitizer: DomSanitizer,
    private _utilService: UtilsService,
    private datePipe: DatePipe,
    private _shareData: DataSharingService
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
  }

  ngOnInit(): void {
    this._data = this.data.billingOperationData;
    const {companySettingsTimezone, displayDateFormat} = this._shareData.getDateConfig();
    this.timezoneOffset = companySettingsTimezone.offSet;

    if(this._data && this._data.targetDate) {
      // const selectedTime = new Date(this._data.targetDate);
      const selectedTime = dayjs(new Date(this._data.targetDate)).utcOffset(this.timezoneOffset);
      let hour: string = selectedTime.hour().toString();
      hour = +hour < 10 ? '0' + hour : hour;
      this.selectedRunTime = hour;
      this.handleDate(this._data.targetDate);
    }
  }

  handleDate(date: Date): void {
    let dateDisplayed: Date;
    if(date){
      dateDisplayed = new Date(this._data.targetDate);
    } else {
      dateDisplayed = new Date(this._data.targetDate);
    }
    this.dateControl.setValue(dateDisplayed);

    // Control time options
    this.handleTimeOptions(dateDisplayed);
  }

  onChangeDate(){
    this.handleTimeOptions(this.dateControl.value)
  }
  
  handleTimeOptions(date: Date): void {
    this._collectionOfTimes = [...collectionOfTime];

    if (this.isToday(date)) {
      const currDate = dayjs(new Date()).utcOffset( this.timezoneOffset);
      const hour = currDate.hour();
      const minutes = currDate.minute();
      this._collectionOfTimes = this._collectionOfTimes.filter(item => {
        const itemHour = parseInt(item.value);
        if (itemHour == (hour + 1) && minutes >= 30) {
          if (parseInt(this.selectedRunTime) == (hour + 1)) {
            item['disabled'] = true
          } else return false;
        };

        return (itemHour > hour)
      });

      if (parseInt(this.selectedRunTime) < hour) {
        this.selectedRunTime = null;
      }
    }
  }
  
  onClose() {
    this._dialogRef.close();
  }

  onSubmit() {
    if (this.selectedRunTime && this.dateControl.valid) {
      const date: Date = this.dateControl.value;
      this._dialogRef.close({ dateTime: this._utilService.convertToUtcNoOffset(date, this.selectedRunTime, this.timezoneOffset)});
    }
  }

  isToday(date) {
    const today =  dayjs(new Date()).utcOffset(this.timezoneOffset).toDate();
    return today.toDateString() === date.toDateString()
  }

}
